/* eslint-disable max-lines */


import {
    ModalContent, ModalFooter, ModalHeader,
} from '../ModalView'

import React, {
    useEffect, useState,
} from 'react'

import {
    copiedText, heading, inviteesWrapper, linkInputWrapper, linkWrapper, modalContent, modalHeaderWrapper,
    privilegesWrapper,
} from './styles'

import {
    styledInput, styledLabel, styledSmall,
} from 'components/Form/styles/FormView'

import {
    useForm, useWatch,
} from 'react-hook-form'

import Button from 'components/Button'
import {ChannelInvitePeopleModalViewProps} from './types'
import {
    HeroUserPlusIcon,
} from 'components/Icon'
import {Icon} from 'components/Icon/types'

import {InviteesTemplate} from 'components/SearchAutocomplete/itemTemplates/templates'
import {
    InviteesTemplateItem,
} from 'components/SearchAutocomplete/types'
import Modal from '../Modal'
import ResultsTable from 'components/ResultsTable'
import {ResultsTableInviteesTemplate} from 'components/ResultsTable/itemTemplates/templates'

import SearchAutocomplete from 'components/SearchAutocomplete'

import Switch from 'components/Switch'
import Tooltip from 'components/Tooltip'


import {isEmail} from 'utils/email'
import {searchAutocompleteResultsButton} from 'components/SearchAutocomplete/styles/SearchAutocomplete.styles'
import {styled} from 'stitches/config'


import {useCopyToClipboard} from 'hooks/clipboard'
import {
    useTranslation,
} from 'react-i18next'


type FormValues = {
    realmMembership: boolean
}

const StyledModalHeaderWrapper = styled('div', modalHeaderWrapper)
const StyledModalContent = styled('div', modalContent)

const StyledInviteesWrapper = styled('div', inviteesWrapper)
const StyledPrivilegesWrapper = styled('div', privilegesWrapper)
const StyledLinkWrapper = styled('div', linkWrapper)
const StyledHeading = styled('h4', heading)

const StyledResultItem = styled('button', searchAutocompleteResultsButton)
const StyledLabel = styled('label', styledLabel)
const StyledInput = styled('input', styledInput)
const StyledLinkInputWrapper = styled('div', linkInputWrapper)
const StyledSmall = styled('span', styledSmall)
const StyledCopiedText = styled('div', copiedText)

const CustomNoResults = ({
    searchValue, handleSelectItem,
}: {searchValue: string, handleSelectItem: (item: InviteesTemplateItem) => (ev: React.MouseEvent) => void}) => {
    const {t} = useTranslation()

    return (
        <StyledResultItem
            onClick={handleSelectItem({
                additionalData: {type: 'email'},
                content: '',
                id: searchValue,
                name: searchValue,
            })}
        >
            <InviteesTemplate action={t('Add')} content='' id='' name={searchValue} realName={t('Invite via email')} />
        </StyledResultItem>
    )
}

const ChannelInvitePeoplePromiseModalView = (props: ChannelInvitePeopleModalViewProps): React.ReactElement => {
    const {
        members, channelName, closeModal, submitModal, inviteUrl, organizationName, generateInvitationLink,
    } = props
    const {t} = useTranslation()
    const {copy} = useCopyToClipboard({})

    const [addedMembers, setAddedMembers] = useState<Array<InviteesTemplateItem>>([])
    const [linkCopied, setLinkCopied] = useState(false)

    const handleItemSelected = (item: InviteesTemplateItem) => {
        if (addedMembers.findIndex((addedItem) => addedItem.id === item.id) === -1) {
            setAddedMembers([...addedMembers, item])
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const handleRemoveItem = (item: InviteesTemplateItem) => () => {
        const addedItemsTemp = [...addedMembers]

        const itemIndex = addedItemsTemp.findIndex((addedItem) => addedItem.id === item.id)
        if (itemIndex !== -1) {
            addedItemsTemp.splice(itemIndex, 1)
            setAddedMembers([...addedItemsTemp])
        }
    }

    const handleCopyToClipboard = () => {
        copy(inviteUrl)
        setLinkCopied(true)

        setTimeout(() => {
            setLinkCopied(false)
        }, 500)
    }

    const handleSubmitForm = (values: FormValues) => {
        if (addedMembers.length > 0) {
            submitModal({
                members: addedMembers,
                realmMembership: values.realmMembership,
            })
        }
    }

    const {
        formState: {isSubmitted},
        control,
        getValues,
        register,
        handleSubmit,
    } = useForm<FormValues>({
        defaultValues: {realmMembership: false},
        mode: 'onSubmit',
        reValidateMode: 'onSubmit',
    })

    const realmMembershipWatch = useWatch({
        control,
        name: 'realmMembership',
    })

    useEffect(() => {
        generateInvitationLink(realmMembershipWatch)
    }, [realmMembershipWatch])

    return (
        <Modal focusTrapListenDOMChanges={true} onClose={closeModal}>
            <form noValidate onSubmit={handleSubmit(handleSubmitForm)}>
                <StyledModalHeaderWrapper>
                    <ModalHeader
                        icon={HeroUserPlusIcon as unknown as Icon}
                        title={t('Invite people to channel {{channel}}', {channel: channelName})}
                        type='success'
                    />
                </StyledModalHeaderWrapper>
                <ModalContent>
                    <StyledModalContent>
                        <StyledPrivilegesWrapper>
                            <StyledHeading>{t('Privileges')}</StyledHeading>
                            <Switch
                                {...register('realmMembership')}
                                horizontal={true}
                                id='realmMembership'
                                label={t('Grant membership to organization {{organizationName}}', {organizationName})}
                                on={getValues('realmMembership')}
                                tabIndex={-1}
                            />
                        </StyledPrivilegesWrapper>
                        <StyledInviteesWrapper>
                            <StyledHeading>{t('Invitees')}</StyledHeading>
                            <StyledLabel>{t('Add invitees')}</StyledLabel>
                            {addedMembers.length === 0 && <StyledSmall error={isSubmitted} role='alert'>{t('Required')}</StyledSmall>}
                            <SearchAutocomplete
                                CustomNoResults={CustomNoResults}
                                Template={InviteesTemplate}
                                clearAfterSelection={true}
                                customNoResultsShowLogic={(searchValue: string, items: Array<InviteesTemplateItem>) => !!(items.length === 0 && isEmail(searchValue))}
                                customResultsHeaderShowLogic={(searchValue: string, items: Array<InviteesTemplateItem>) => !!(items.length === 0 && isEmail(searchValue))}
                                dropdownHeight={190}
                                featuredItems={members.slice(0, 10)} // 10 first items displayed without searching
                                itemSelected={handleItemSelected}
                                items={members}
                                placeholder={t('Add invitee email address or username')}
                                tabIndex={-1}
                            />
                            {addedMembers.length > 0 &&
                            <ResultsTable
                                Template={ResultsTableInviteesTemplate}
                                columns={[
                                    'Avatar', 'Name', 'Remove',
                                ]}
                                headerText={t('{{count}} invitees', {count: addedMembers.length})}
                                includeColumnNames={false}
                                includeHeader
                                items={addedMembers.map((item: InviteesTemplateItem) => ({
                                    content: '',
                                    handleRemove: handleRemoveItem(item),
                                    id: item.id,
                                    name: item.name,
                                }))}
                                tabIndex={-1}
                            />}
                        </StyledInviteesWrapper>
                        <StyledLinkWrapper>
                            <StyledHeading>{t('Sharable invitation link')}</StyledHeading>
                            <StyledLinkInputWrapper>
                                <StyledInput
                                    id='channelInviteLink'
                                    name='channelInviteLink'
                                    readOnly
                                    tabIndex={-1}
                                    type='text'
                                    value={inviteUrl}
                                />
                                <Tooltip id='copied-info' singleLine>
                                    {linkCopied ? <StyledCopiedText>{t('Copied')}</StyledCopiedText> : null}
                                </Tooltip>
                                <div data-tooltip-id='copied-info'>
                                    <Button onPress={handleCopyToClipboard} tabIndex={-1} text={t('Copy link')} type='button' />
                                </div>
                            </StyledLinkInputWrapper>
                        </StyledLinkWrapper>
                    </StyledModalContent>
                </ModalContent>
                <ModalFooter>
                    <Button
                        onPress={closeModal}
                        size='large'
                        tabIndex={-1}
                        text={t('Cancel')}
                    />
                    <Button color='filled' margin='left' size='large' tabIndex={-1} text={t('Send invitation')} type='submit' />
                </ModalFooter>
            </form>
        </Modal>
    )
}

export default ChannelInvitePeoplePromiseModalView
